import AsyncPaymentsContainer from "../containers/Payment/PaymentsContainer";
// import BudgetChartContainer from "../components/Budget/BudgetChartContainer";
import BudgetContainer from "../components/Budget/BudgetContainer";
// import ClientsContainer from "../containers/Contacts/ClientsContainer";
import CostsContainer from "../components/Cost/CostsContainer";
import EarningsContainer from "../components/Earning/EarningsContainer";
import Loadable from "react-loadable";
import PerformanceReportContainer from "../components/PerformanceReport/PerformanceReportContainer";
import ProjectSettingsContainer from "../containers/Projects/ProjectSettingsContainer";
import React from "react";
import RentabilityContainer from "../components/Rentability/RentabilityContainer";
import SalesContainer from "../components/Sale/SalesContainer";
import Spinner from "../elements/Spinner/Spinner";
import TaxContainer from "../components/Tax/TaxContainer";
import TaxReportContainer from "../components/TaxReport/TaxReportContainer";
import TreasuryContainer from "../components/Treasury/TreasuryContainer";
import { parse } from "url";

let LoadableSpinner = () => <Spinner size="lg" fullScreen />;

const AsyncInvoicesContainer = Loadable({
  loader: () =>
    import(
      "../containers/Invoice/InvoicesContainer" /* webpackChunkName: "chunk-InvoicesContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-InvoicesContainer"]
});

// const AsyncOnboardingWizard = Loadable({
//   loader: () =>
//     import("../components/onboarding/Wizard" /* webpackChunkName: "chunk-onboardingWizard" */),
//   loading: LoadableSpinner,
//   modules: ["chunk-onboardingWizard"]
// });

// const AsyncOnboardingWizard = asyncComponent(() =>
//   import("../components/onboarding/Wizard")
// );

const AsyncClientsContainer = Loadable({
  loader: () =>
    import(
      "../containers/Contacts/ClientsContainer" /* webpackChunkName: "chunk-ClientsContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-ClientsContainer"]
});

// const AsyncClientsContainer = asyncComponent(() =>
//   import("../containers/Contacts/ClientsContainer")
// );

const AsyncOdooPartnersContainer = Loadable({
  loader: () =>
    import(
      "../containers/Contacts/OdooPartnersContainer" /* webpackChunkName: "chunk-CollaboratorsContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-OdooPartnersContainer"]
});

const AsyncCollaboratorsContainer = Loadable({
  loader: () =>
    import(
      "../containers/Contacts/CollaboratorsContainer" /* webpackChunkName: "chunk-CollaboratorsContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-CollaboratorsContainer"]
});

// const AsyncCollaboratorsContainer = asyncComponent(() =>
//   import("../containers/Contacts/CollaboratorsContainer")
// );

const AsyncSuppliersContainer = Loadable({
  loader: () =>
    import(
      "../containers/Contacts/SuppliersContainer" /* webpackChunkName: "chunk-SuppliersContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-SuppliersContainer"]
});

// const AsyncSuppliersContainer = asyncComponent(() =>
//   import("../containers/Contacts/SuppliersContainer")
// );

const AsyncExpensesContainer = Loadable({
  loader: () =>
    import(
      "../containers/Expense/ExpensesContainer" /* webpackChunkName: "chunk-ExpensesContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-ExpensesContainer"]
});

// const AsyncExpensesContainer = asyncComponent(() =>
//   import("../containers/Expense/ExpensesContainer")
// );

const AsyncExportsContainer = Loadable({
  loader: () =>
    import(
      "../containers/Exports/ExportsContainer" /* webpackChunkName: "chunk-ExportsContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-ExportsContainer"]
});

const AsyncAccountingContainer = Loadable({
  loader: () =>
    import(
      "../containers/Accounting/AccountingContainer" /* webpackChunkName: "chunk-AccountingContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-AccountingContainer"]
});

const AsyncCodeJournalContainer = Loadable({
  loader: () =>
    import(
      "../containers/CodeJournal/CodeJournalContainer" /* webpackChunkName: "chunk-CodeJournalContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-CodeJournalContainer"]
});

// const AsyncAccountingContainer = asyncComponent(() =>
//   import("../containers/Accounting/AccountingContainer")
// );

// const AsyncPaymentsContainer = Loadable({
//   loader: () =>
//     import("../containers/Payment/PaymentsContainer" /* webpackChunkName: "chunk-PaymentsContainer" */),
//   loading: LoadableSpinner,
//   modules: ["chunk-PaymentsContainer"]
// });
// const AsyncPaymentsContainer = asyncComponent(() =>
//   import("../containers/Payment/PaymentsContainer")
// );

// const AsyncEmailSettingsContainer = Loadable({
//   loader: () =>
//     import("../containers/Emails/EmailSettingsContainer" /* webpackChunkName: "chunk-EmailSettingsContainer" */),
//   loading: LoadableSpinner,
//   modules: ["chunk-EmailSettingsContainer"]
// });

// const AsyncEmailSettingsContainer = asyncComponent(() =>
//   import("../containers/Emails/EmailSettingsContainer")
// );

// const AsyncProjectSettingsContainer = Loadable({
//   loader: () =>
//     import("../containers/Projects/ProjectSettingsContainer" /* webpackChunkName: "chunk-ProjectSettingsContainer" */),
//   loading: LoadableSpinner,
//   modules: ["chunk-ProjectSettingsContainer"]
// });

// const AsyncProjectSettingsContainer = asyncComponent(() =>
//   import("../containers/Projects/ProjectSettingsContainer")
// );

// const AsyncCompanies = Loadable({
//   loader: () =>
//     import("../views/Companies" /* webpackChunkName: "chunk-companies" */),
//   loading: LoadableSpinner,
//   modules: ["chunk-companies"]
// });
// const AsyncCompanies = asyncComponent(() => import("../views/Companies"));

const AsyncArticles = Loadable({
  loader: () =>
    import(
      "../containers/Articles/ArticlesContainer" /* webpackChunkName: "chunk-articles" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-articles"]
});

// const AsyncArticles = asyncComponent(() => import("../containers/Articles"));

const AsyncProfilePage = Loadable({
  loader: () =>
    import("../views/ProfilePage" /* webpackChunkName: "chunk-ProfilePage" */),
  loading: LoadableSpinner,
  modules: ["chunk-ProfilePage"]
});
// const AsyncProfilePage = asyncComponent(() => import("../views/ProfilePage"));

const AsyncCompanyEditPage = Loadable({
  loader: () =>
    import(
      "../views/CompanyEditPage" /* webpackChunkName: "chunk-CompanyEditPage" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-CompanyEditPage"]
});
// const AsyncCompanyEditPage = asyncComponent(() =>
//   import("../views/CompanyEditPage")
// );

const AsyncDocumentSettingsPage = Loadable({
  loader: () =>
    import(
      "../views/DocumentSettingsPage" /* webpackChunkName: "chunk-CompanyEditPage" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-DocumentSettingsPage"]
});

// const AsyncPlansContainer = Loadable({
//   loader: () =>
//     import(
//       "../containers/Plans/PlansContainer" /* webpackChunkName: "chunk-CompanyEditPage" */
//     ),
//   loading: LoadableSpinner,
//   modules: ["chunk-PlansContainer"]
// });

const AsyncDashboard = Loadable({
  loader: () =>
    import(
      "../views/Dashboard/Dashboard" /* webpackChunkName: "chunk-Dashboard" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-Dashboard"]
});
// const AsyncDashboard = asyncComponent(() =>
//   import("../views/Dashboard/Dashboard")
// );

const AsyncCategoriesContainer = Loadable({
  loader: () =>
    import(
      "../containers/Categories/CategoriesContainer" /* webpackChunkName: "CategoriesContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-CategoriesContainer"]
});
// const AsyncCategoriesContainer = asyncComponent(() =>
//   import("../containers/Categories/CategoriesContainer")
// );

//var pages = [{ path: "/pages/user-page", name: "User Page", mini: "UP", component: UserPage }].concat(pagesRoutes);

// only used in dev to autgenerate translation candidates
// eslint-disable-next-line

// let expenses_str = intlShape.formatMessage(messages.dash_exenses); // "Hello, Eric!"

// const Quotations = () => <div>MOCK DEVIS</div>;
const AsyncQuotationsContainer = Loadable({
  loader: () =>
    import(
      "../containers/quotation/quotationsContainer" /* webpackChunkName: "chunk-InvoicesContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-QuotationContainer"]
});



//--------------------------- ODOO MENU
const AsyncDashboardForOdoo = Loadable({
  loader: () =>
    import(
      "../containers/Odoo/OdooImportContainer" /* webpackChunkName: "chunk-ExportsContainer" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-OdooImportContainer"]
});

const AsyncOdooImportSettings = Loadable({
  loader: () =>
    import(
      "../views/OdooImportSettingsPage" /* webpackChunkName: "chunk-CompanyEditPage" */
    ),
  loading: LoadableSpinner,
  modules: ["chunk-OdooImportSettingsPage"]
});

//---------------------------


const Operations = () => <div>MOCK Operations</div>;

const Contacts = () => <div>MOCK Contacts</div>;

const Reports = () => <div>MOCK Reports</div>;

// const Budgets = () => <div>MOCK Budgets</div>;

const Compta = () => <div>MOCK Compta</div>;

const Settings = () => <div>MOCK Settings</div>;

function dashRoutes(props) {
  const role = props.role;
  const loggedEmail = props.loggedEmail || "";
  const defaultMenu = props.companyOptions ? JSON.parse(props.companyOptions).default : true;
  const odooMenu = props.companyOptions ? JSON.parse(props.companyOptions).odoo : false;

  var dashRoutesTotalArray = [];

  var dashRoutesArray = [];
  var dashRoutesOdooArray = [];

  // console.log("268 - props=", props);
  // console.log("276 - menus=", JSON.parse(props.companyOptions));


  // ----------------------------ADMIN -----------------------------------------------------------
  if (defaultMenu) {

    if (role === "ADMIN") {
      dashRoutesArray = [
        {
          path: "/dashboard",
          name: "ids_dashboard",
          icon: "pe-7s-home",
          component: AsyncDashboard
        },
        {
          path: "/invoices",
          name: "ids_sales",
          icon: "pe-7s-note2",
          component: AsyncInvoicesContainer
        },
        // {
        //   path: "/quotations",
        //   name: "ids_quotations",
        //   icon: "pe-7s-note2",
        //   component: AsyncQuotationsContainer
        // },
        {
          path: "/expenses",
          name: "ids_expenses",
          icon: "pe-7s-cart",
          component: AsyncExpensesContainer
        },
        {
          path: "/payments",
          name: "ids_banks",
          icon: "pe-7s-credit",
          component: AsyncPaymentsContainer
        },
        {
          collapse: true,
          path: "/invoices",
          state: "openOperations",
          name: "ids_operations",
          icon: "pe-7s-note2",
          visible: false,     // HIDE MENU
          component: Operations,
          views: [
            {
              path: "/invoices",
              name: "ids_sales",
              icon: "pe-7s-note2",
              component: AsyncInvoicesContainer
            },
            {
              path: "/quotations",
              name: "ids_sales",
              icon: "fa fa-money",
              component: AsyncQuotationsContainer
            }
          ]
        },

        {
          path: "/clients",
          name: "ids_contacts",
          icon: "pe-7s-users",
          component: AsyncClientsContainer,
        },

        {
          collapse: true,
          path: "/clients",
          state: "openContacts",
          name: "ids_contacts",
          icon: "pe-7s-users",
          visible: false,     // HIDE MENU
          component: Contacts,
          views: [
            {
              path: "/clients",
              name: "ids_contacts",
              mini: "Cl",
              component: AsyncClientsContainer
            },
            {
              path: "/suppliers",
              name: "ids_contacts",
              mini: "F",
              component: AsyncSuppliersContainer
            },
            {
              path: "/collaborators",
              name: "ids_contacts",
              mini: "Co",
              component: AsyncCollaboratorsContainer
            },
            {
              path: "/comptables",
              name: "ids_contacts",
              mini: "Cp",
              component: AsyncCollaboratorsContainer
            }
          ]
        },

        {
          path: "/reports/sales",
          name: "ids_reports",
          icon: "pe-7s-graph2",
          component: SalesContainer
        },
        {
          collapse: true,
          visible: false,
          path: "/reports/sales",
          state: "openReports",
          name: "ids_reports",
          icon: "pe-7s-graph2",
          component: Reports,
          views: [
            {
              path: "/reports/sales",
              name: "ids_sales",
              mini: "SL",
              component: SalesContainer
            },
            {
              path: "/reports/earnings",
              name: "ids_earnings",
              mini: "RV",
              component: EarningsContainer
            },
            {
              path: "/reports/costs",
              name: "ids_costs",
              mini: "CS",
              component: CostsContainer
            },
            {
              path: "/reports/rentability",
              name: "ids_rentability",
              mini: "RE",
              component: RentabilityContainer
            },
            {
              path: "/reports/treasury",
              name: "ids_treasury",
              mini: "TR",
              component: TreasuryContainer
            },
            {
              path: "/reports/taxes",
              name: "ids_taxes",
              mini: "TX",
              component: TaxReportContainer
            },
            {
              path: "/reports/performance",
              name: "ids_performance",
              mini: "PE",
              component: PerformanceReportContainer
            }
          ]
        },
        {
          path: "/budget/clients",
          name: "ids_budget",
          icon: "pe-7s-calculator",
          component: BudgetContainer,
        },
        {
          collapse: true,
          visible: false,     // HIDE MENU
          path: "/budget/clients",
          state: "openBudget",
          name: "ids_budget",
          icon: "pe-7s-calculator",
          component: Reports,
          views: [
            {
              path: "/budget/clients",
              name: "ids_budgetClient",
              mini: "BC",
              component: BudgetContainer
            },
            {
              path: "/budget/categories",
              name: "ids_budgetCategory",
              mini: "Bc",
              component: BudgetContainer
            },
            {
              path: "/budget/clientReport",
              name: "ids_budgetClientReport",
              mini: "BCR",
              component: BudgetContainer
            },
            {
              path: "/budget/categoryReport",
              name: "ids_budgetCategoryReport",
              mini: "BCr",
              component: BudgetContainer
            }
          ]
        },
        {
          path: "/accounting/exports",
          name: "ids_accounting",
          icon: "pe-7s-graph2",
          component: AsyncExportsContainer
        },
        {
          collapse: true,
          visible: false,
          path: "/accounting/exports",
          state: "openAccounting",
          name: "ids_accounting",
          icon: "pe-7s-piggy",
          component: Compta,
          views: [
            {
              path: "/accounting/exports",
              name: "ids_accounting",
              mini: "EX",
              component: AsyncExportsContainer
            },
            {
              path: "/accounting/plan",
              name: "ids_accounting",
              mini: "PC",
              component: AsyncAccountingContainer
            },
            {
              path: "/accounting/codejournal",
              name: "ids_accounting",
              mini: "CJ",
              component: AsyncCodeJournalContainer
            }
          ]
        },
        {
          path: "/settings/company",
          // name: 'Entreprise',
          icon: "pe-7s-config",
          name: "ids_settings",
          mini: "CE",
          component: AsyncCompanyEditPage
        },
        {
          collapse: true,
          path: "/settings/company",
          state: "openSettings",
          icon: "pe-7s-config",
          name: "ids_settings",
          component: Settings,
          visible: false,     // HIDE MENU
          views: [
            // {
            //   path: "/plans",
            //   name: "ids_plans",
            //   mini: "PL",
            //   component: AsyncPlansContainer
            // },
            {
              path: "/settings/company",
              // name: 'Entreprise',
              name: "ids_settings",
              mini: "CE",
              component: AsyncCompanyEditPage
            },
            {
              path: "/settings/documents",
              name: "ids_settings",
              mini: "DO",
              component: AsyncDocumentSettingsPage
            },
            {
              visible: false,
              path: "/settings/profile",
              name: "ids_settings",
              mini: "UP",
              component: AsyncProfilePage
            },

            {
              path: "/settings/projects",
              name: "ids_settings",
              mini: "PJ",
              component: ProjectSettingsContainer
            },
            {
              path: "/settings/categories",
              name: "ids_settings",
              mini: "CA",
              component: AsyncCategoriesContainer
            },
            {
              path: "/settings/articles",
              name: "ids_settings",
              mini: "AR",
              component: AsyncArticles
            },
            {
              path: "/settings/taxes",
              name: "ids_settings",
              mini: "TX",
              component: TaxContainer
            }
          ]
        }
      ];
      // ----------------------------ADMIN -----------------------------------------------------------
      // ----------------------------COMPTABLE -------------------------------------------------------
    } else if (role === "COMPTABLE") {
      dashRoutesArray = [
        {
          path: "/dashboard",
          name: "ids_dashboard",
          icon: "pe-7s-home",
          component: AsyncDashboard
        },
        {
          path: "/invoices",
          name: "ids_sales",
          icon: "pe-7s-note2",
          component: AsyncInvoicesContainer
        },
        // {
        //   path: "/quotations",
        //   name: "ids_quotations",
        //   icon: "pe-7s-note2",
        //   component: AsyncQuotationsContainer
        // },
        {
          path: "/expenses",
          name: "ids_expenses",
          icon: "pe-7s-cart",
          component: AsyncExpensesContainer
        },
        {
          path: "/payments",
          name: "ids_banks",
          icon: "pe-7s-credit",
          component: AsyncPaymentsContainer
        },
        {
          collapse: true,
          path: "/invoices",
          state: "openOperations",
          name: "ids_operations",
          icon: "pe-7s-note2",
          visible: false,     // HIDE MENU
          component: Operations,
          views: [
            {
              path: "/invoices",
              name: "ids_sales",
              icon: "pe-7s-note2",
              component: AsyncInvoicesContainer
            },
            {
              path: "/quotations",
              name: "ids_sales",
              icon: "fa fa-money",
              component: AsyncQuotationsContainer
            }
          ]
        },
        {
          path: "/clients",
          name: "ids_contacts",
          icon: "pe-7s-users",
          component: AsyncClientsContainer,
        },

        {
          collapse: true,
          path: "/clients",
          state: "openContacts",
          name: "ids_contacts",
          icon: "pe-7s-users",
          visible: false,     // HIDE MENU
          component: Contacts,
          views: [
            {
              path: "/clients",
              name: "ids_contacts",
              mini: "Cl",
              component: AsyncClientsContainer
            },
            {
              path: "/suppliers",
              name: "ids_contacts",
              mini: "F",
              component: AsyncSuppliersContainer
            },
            {
              path: "/collaborators",
              name: "ids_contacts",
              mini: "Co",
              component: AsyncCollaboratorsContainer
            },
            {
              path: "/comptables",
              name: "ids_contacts",
              mini: "Cp",
              component: AsyncCollaboratorsContainer
            }
          ]
        },
        {
          path: "/reports/sales",
          name: "ids_reports",
          icon: "pe-7s-graph2",
          component: SalesContainer
        },
        {
          collapse: true,
          visible: false,
          path: "/reports/sales",
          state: "openReports",
          name: "ids_reports",
          icon: "pe-7s-graph2",
          component: Reports,
          views: [
            {
              path: "/reports/sales",
              name: "ids_sales",
              mini: "SL",
              component: SalesContainer
            },
            {
              path: "/reports/earnings",
              name: "ids_earnings",
              mini: "RV",
              component: EarningsContainer
            },
            {
              path: "/reports/costs",
              name: "ids_costs",
              mini: "CS",
              component: CostsContainer
            },
            {
              path: "/reports/rentability",
              name: "ids_rentability",
              mini: "RE",
              component: RentabilityContainer
            },
            {
              path: "/reports/treasury",
              name: "ids_treasury",
              mini: "TR",
              component: TreasuryContainer
            },
            {
              path: "/reports/taxes",
              name: "ids_taxes",
              mini: "TX",
              component: TaxReportContainer
            },
            {
              path: "/reports/performance",
              name: "ids_performance",
              mini: "PE",
              component: PerformanceReportContainer
            }
          ]
        },
        {
          path: "/budget/clients",
          name: "ids_budget",
          icon: "pe-7s-calculator",
          component: BudgetContainer,
        },
        {
          collapse: true,
          visible: false,     // HIDE MENU
          path: "/budget/clients",
          state: "openBudget",
          name: "ids_budget",
          icon: "pe-7s-calculator",
          component: Reports,
          views: [
            {
              path: "/budget/clients",
              name: "ids_budgetClient",
              mini: "BC",
              component: BudgetContainer
            },
            {
              path: "/budget/clientReport",
              name: "ids_budgetClientReport",
              mini: "BCR",
              component: BudgetContainer
            }
          ]
        },
        {
          path: "/accounting/exports",
          name: "ids_accounting",
          icon: "pe-7s-graph2",
          component: AsyncExportsContainer
        },
        {
          collapse: true,
          visible: false,
          path: "/accounting/exports",
          state: "openAccounting",
          name: "ids_accounting",
          icon: "pe-7s-piggy",
          component: Compta,
          views: [
            {
              path: "/accounting/exports",
              name: "ids_exports",
              mini: "EX",
              component: AsyncExportsContainer
            },
            {
              path: "/accounting/plan",
              name: "ids_accountingPlan",
              mini: "PC",
              component: AsyncAccountingContainer
            },
            {
              path: "/accounting/codejournal",
              name: "ids_codeJournal",
              mini: "CJ",
              component: AsyncCodeJournalContainer
            }
          ]
        },
        {
          collapse: true,
          path: "/settings/company",
          state: "openSettings",
          icon: "pe-7s-config",
          name: "ids_settings",
          component: Settings,
          visible: false,     // HIDE MENU
          views: [
            // {
            //   path: "/plans",
            //   name: "ids_plans",
            //   mini: "PL",
            //   component: AsyncPlansContainer
            // },
            {
              path: "/settings/company",
              // name: 'Entreprise',
              name: "ids_settings",
              mini: "CE",
              component: AsyncCompanyEditPage
            },
            {
              path: "/settings/documents",
              name: "ids_settings",
              mini: "DO",
              component: AsyncDocumentSettingsPage
            },
            {
              visible: false,
              path: "/settings/profile",
              name: "ids_settings",
              mini: "UP",
              component: AsyncProfilePage
            },

            {
              path: "/settings/projects",
              name: "ids_settings",
              mini: "PJ",
              component: ProjectSettingsContainer
            },
            {
              path: "/settings/categories",
              name: "ids_settings",
              mini: "CA",
              component: AsyncCategoriesContainer
            },
            {
              path: "/settings/articles",
              name: "ids_settings",
              mini: "AR",
              component: AsyncArticles
            },
            {
              path: "/settings/taxes",
              name: "ids_settings",
              mini: "TX",
              component: TaxContainer
            }
          ]
        }
      ];
      // ----------------------------COMPTABLE -------------------------------------------------------
      // ----------------------------COMMERCIAL ------------------------------------------------------
    } else if (role === "COMMERCIAL") {
      dashRoutesArray = [
        {
          path: "/dashboard",
          name: "ids_dashboard",
          icon: "pe-7s-home",
          component: AsyncDashboard
        },
        {
          path: "/invoices",
          name: "ids_sales",
          icon: "pe-7s-note2",
          component: AsyncInvoicesContainer
        },
        // {
        //   path: "/quotations",
        //   name: "ids_quotations",
        //   icon: "pe-7s-note2",
        //   component: AsyncQuotationsContainer
        // },
        {
          path: "/expenses",
          name: "ids_expenses",
          icon: "pe-7s-cart",
          component: AsyncExpensesContainer
        },
        {
          path: "/payments",
          name: "ids_banks",
          icon: "pe-7s-credit",
          visible: false,     // HIDE MENU
          component: AsyncPaymentsContainer
        },
        {
          collapse: true,
          path: "/invoices",
          state: "openOperations",
          name: "ids_operations",
          icon: "pe-7s-note2",
          visible: false,     // HIDE MENU
          component: Operations,
          views: [
            {
              path: "/invoices",
              name: "ids_sales",
              icon: "pe-7s-note2",
              component: AsyncInvoicesContainer
            },
            {
              path: "/quotations",
              name: "ids_sales",
              icon: "fa fa-money",
              component: AsyncQuotationsContainer
            }
          ]
        },
        {
          path: "/clients",
          name: "ids_contacts",
          icon: "pe-7s-users",
          component: AsyncClientsContainer,
        },

        {
          collapse: true,
          path: "/clients",
          state: "openContacts",
          name: "ids_contacts",
          icon: "pe-7s-users",
          visible: false,     // HIDE MENU
          component: Contacts,
          views: [
            {
              path: "/clients",
              name: "ids_contacts",
              mini: "Cl",
              component: AsyncClientsContainer
            },
            {
              path: "/collaborators",
              name: "ids_contacts",
              mini: "Co",
              component: AsyncCollaboratorsContainer
            },
          ]
        },
        {
          path: "/reports/sales",
          name: "ids_reports",
          icon: "pe-7s-graph2",
          component: SalesContainer
        },
        {
          collapse: true,
          visible: false,
          path: "/reports/sales",
          state: "openReports",
          name: "ids_reports",
          icon: "pe-7s-graph2",
          component: Reports,
          views: [
            {
              path: "/reports/sales",
              name: "ids_sales",
              mini: "SL",
              component: SalesContainer
            }
            // {
            //   path: "/reports/budget",
            //   name: "ids_budgets",
            //   mini: "BU",
            //   component: BudgetChartContainer
            // }
          ]
        },
        {
          path: "/budget/clients",
          name: "ids_budget",
          icon: "pe-7s-calculator",
          component: BudgetContainer,
        },
        {
          collapse: true,
          visible: false,     // HIDE MENU
          collapse: true,
          path: "/budget/clients",
          state: "openBudget",
          name: "ids_budget",
          icon: "pe-7s-calculator",
          component: Reports,
          views: [
            {
              path: "/budget/clients",
              name: "ids_budgetClient",
              mini: "BC",
              component: BudgetContainer
            },
            {
              path: "/budget/clientReport",
              name: "ids_budgetClientReport",
              mini: "BCR",
              component: BudgetContainer
            }
          ]
        },
        {
          collapse: true,
          path: "/settings/profile",
          visible: false,
          state: "openSettings",
          icon: "pe-7s-config",
          name: "ids_settings",
          component: Settings,
          views: [
            {
              visible: false,
              path: "/settings/profile",
              name: "ids_settings",
              mini: "UP",
              component: AsyncProfilePage
            }
          ]
        }
      ];

      // ----------------------------COMMERCIAL ------------------------------------------------------
    } else if (role === "COLLABORATOR") {
      dashRoutesArray = [
        {
          path: "/dashboard",
          name: "ids_dashboard",
          icon: "pe-7s-home",
          component: AsyncDashboard
        },
        // {
        //   path: "/invoices",
        //   name: "ids_sales",
        //   icon: "pe-7s-note2",
        //   component: AsyncInvoicesContainer
        // },      
        {
          path: "/expenses",
          name: "ids_expenses",
          icon: "pe-7s-cart",
          component: AsyncExpensesContainer
        },
        {
          path: "/payments",
          name: "ids_banks",
          icon: "pe-7s-credit",
          visible: false,     // HIDE MENU
          component: AsyncPaymentsContainer
        },
        // {
        //   collapse: true,
        //   path: "/invoices",
        //   state: "openOperations",
        //   name: "ids_operations",
        //   icon: "pe-7s-note2",
        //   visible: false,     // HIDE MENU
        //   component: Operations,
        //   views: [
        //     {
        //       path: "/invoices",
        //       name: "ids_sales",
        //       icon: "pe-7s-note2",
        //       component: AsyncInvoicesContainer
        //     },
        //     {
        //       path: "/quotations",
        //       name: "ids_sales",
        //       icon: "fa fa-money",
        //       component: AsyncQuotationsContainer
        //     }
        //   ]
        // },
        {
          path: "/collaborators",
          name: "ids_contacts",
          icon: "pe-7s-users",
          component: AsyncCollaboratorsContainer,
        },

        {
          collapse: true,
          path: "/collaborators",
          state: "openContacts",
          name: "ids_contacts",
          icon: "pe-7s-users",
          visible: false,     // HIDE MENU
          component: Contacts,
          views: [
            {
              path: "/collaborators",
              name: "ids_contacts",
              mini: "Cl",
              component: AsyncCollaboratorsContainer
            }
          ]
        },
        {
          collapse: true,
          visible: false,
          path: "/reports/sales",
          state: "openReports",
          name: "ids_reports",
          icon: "pe-7s-graph2",
          component: Reports,
          views: [
            {
              path: "/reports/sales",
              name: "ids_sales",
              mini: "SL",
              component: SalesContainer
            }
          ]
        },
        {
          collapse: true,
          visible: false,
          path: "/budget/clients",
          state: "openBudget",
          name: "ids_budget",
          icon: "pe-7s-calculator",
          component: Reports,
          views: [
            {
              path: "/budget/clients",
              name: "ids_budgetClient",
              mini: "BC",
              component: BudgetContainer
            },
            {
              path: "/budget/clientReport",
              name: "ids_budgetClientReport",
              mini: "BCR",
              component: BudgetContainer
            }
          ]
        },
        {
          collapse: true,
          path: "/settings/profile",
          visible: false,
          state: "openSettings",
          icon: "pe-7s-config",
          name: "ids_settings",
          component: Settings,
          views: [
            {
              visible: false,
              path: "/settings/profile",
              name: "ids_settings",
              mini: "UP",
              component: AsyncProfilePage
            }
          ]
        }
      ];
    }
  }

  if (odooMenu) {

    
    if (defaultMenu) {
      dashRoutesOdooArray.push(
        {
          path: "NO PATH LINE",
          name: "ids_line",
          icon: "",
          component: null,
          isSeparationLine: true
        }
      );
    }

    if (role === "ADMIN") {
      dashRoutesOdooArray.push(
        {
          path: "/odooimport/dashboard",
          name: "ids_importToOdoo",
          icon: "pe-7s-cloud-upload",
          component: AsyncDashboardForOdoo
        }
      );

      if (
        loggedEmail.toLowerCase().indexOf("@softthinks.com") !== -1 ||
        loggedEmail.toLowerCase() === "support@netwips.com"
      ) {

        dashRoutesOdooArray.push(
          {
            path: "/odooimport/collaborators",
            name: "ids_contacts",
            icon: "pe-7s-users",
            component: AsyncCollaboratorsContainer,
          },

          {
            collapse: true,
            path: "/odooimport/collaborators",
            state: "openContacts",
            name: "ids_contacts",
            icon: "pe-7s-users",
            visible: false,     // HIDE MENU
            component: Contacts,
            views: [
              {
                path: "/odooimport/partners",
                name: "ids_contacts",
                mini: "Cl",
                component: AsyncOdooPartnersContainer
              },
              {
                path: "/odooimport/collaborators",
                name: "ids_contacts",
                mini: "Co",
                component: AsyncCollaboratorsContainer
              }
            ]
          });
      }

      dashRoutesOdooArray.push(
        {
          path: "/odooimport/settings",
          name: "ids_odooSettings",
          //name : "ids_importToOdoo",
          icon: "pe-7s-config",
          component: AsyncOdooImportSettings
        },
        {
          collapse: true,
          path: "/settings/profile",
          visible: false,
          state: "openSettings",
          icon: "pe-7s-config",
          name: "ids_settings",
          component: Settings,
          views: [
            {
              visible: false,
              path: "/settings/profile",
              name: "ids_settings",
              mini: "UP",
              component: AsyncProfilePage
            }
          ]
        }
      )

      if (
        loggedEmail.toLowerCase().indexOf("@softthinks.com") !== -1 ||
        loggedEmail.toLowerCase() === "support@netwips.com"
      ) {

        dashRoutesOdooArray.push(
          {
            path: "/settings/taxes",
            name: "ids_taxes",
            icon: "pe-7s-more",
            component: TaxContainer
          },
          {
            collapse: true,
            path: "/settings/taxes",
            visible: false,
            state: "openSettings",
            icon: "pe-7s-more",
            name: "ids_taxes",
            component: TaxContainer,
            views: [
              {
                visible: false,
                path: "/settings/taxes",
                name: "ids_taxes",
                mini: "UP",
                component: TaxContainer
              }
            ]
          }
        );
      }


      // ----------------------------ADMIN -----------------------------------------------------------
    } else if (role === "COLLABORATOR") {
      dashRoutesOdooArray = [
        {
          path: "/odooimport/dashboard",
          name: "ids_importToOdoo",
          icon: "pe-7s-cloud-upload",
          component: AsyncDashboardForOdoo
        },
        {
          path: "/odooimport/settings",
          name: "ids_odooSettings",
          //name : "ids_importToOdoo",
          icon: "pe-7s-config",
          component: AsyncOdooImportSettings
        },

        {
          collapse: true,
          path: "/settings/profile",
          visible: false,
          state: "openSettings",
          icon: "pe-7s-config",
          name: "ids_settings",
          component: Settings,
          views: [
            {
              visible: false,
              path: "/settings/profile",
              name: "ids_settings",
              mini: "UP",
              component: AsyncProfilePage
            }
          ]
        }
      ];
      // ----------------------------ADMIN -----------------------------------------------------------
      // ----------------------------COMPTABLE -------------------------------------------------------
    } else if (role === "COMPTABLE") {
      dashRoutesOdooArray = [
        {
          path: "/dashboard",
          name: "ids_dashboard",
          icon: "pe-7s-home",
          component: AsyncDashboard
        }
      ]
    }
  }



  dashRoutesTotalArray = [...dashRoutesArray, ...dashRoutesOdooArray];
  return dashRoutesTotalArray;
}

/*
var xdashRoutes = [
  {
    path: "/dashboard",
    name: "ids_dashboard",
    icon: "pe-7s-home",
    component: AsyncDashboard
  },
  {
    path: "/quotations",
    name: "ids_quotations",
    icon: "fa fa-money",
    component: AsyncQuotationsContainer
  },
  {
    path: "/invoices",
    name: "ids_invoices",
    icon: "pe-7s-note2",
    component: AsyncInvoicesContainer
  },
  {
    path: "/expenses",
    name: "ids_expenses",
    icon: "pe-7s-cart",
    component: AsyncExpensesContainer
  },
  {
    path: "/payments",
    name: "ids_banks",
    icon: "pe-7s-credit",
    component: AsyncPaymentsContainer
  },
  {
    collapse: true,
    path: "/clients",
    state: "openContacts",
    name: "ids_contacts",
    icon: "pe-7s-users",
    component: Contacts,
    views: [
      {
        path: "/clients",
        name: "ids_clients",
        mini: "Cl",
        component: AsyncClientsContainer
      },
      {
        path: "/suppliers",
        name: "ids_suppliers",
        mini: "F",
        component: AsyncSuppliersContainer
      },
      {
        path: "/collaborators",
        name: "ids_collaborators",
        mini: "Co",
        component: AsyncCollaboratorsContainer
      },
      {
        path: "/comptables",
        name: "ids_accountant",
        mini: "Cp",
        component: AsyncCollaboratorsContainer
      }
    ]
  },
  {
    collapse: true,
    path: "/reports/sales",
    state: "openReports",
    name: "ids_reports",
    icon: "pe-7s-graph2",
    component: Reports,
    views: [
      {
        path: "/reports/sales",
        name: "ids_sales",
        mini: "SL",
        component: SalesContainer
      },
      {
        path: "/reports/earnings",
        name: "ids_earnings",
        mini: "RV",
        component: EarningsContainer
      },
      {
        path: "/reports/costs",
        name: "ids_costs",
        mini: "CS",
        component: CostsContainer
      },
      {
        path: "/reports/rentability",
        name: "ids_rentability",
        mini: "RE",
        component: RentabilityContainer
      },
      {
        path: "/reports/treasury",
        name: "ids_treasury",
        mini: "TR",
        component: TreasuryContainer
      }
    ]
  },
  {
    collapse: true,
    path: "/accounting/exports",
    state: "openAccounting",
    name: "ids_accounting",
    icon: "pe-7s-piggy",
    //component: AsyncAccountingContainer,
    component: Compta,
    views: [
      {
        path: "/accounting/exports",
        name: "ids_exports",
        mini: "EX",
        component: AsyncExportsContainer
      },
      {
        path: "/accounting/plan",
        name: "ids_accountingPlan",
        mini: "PC",
        component: AsyncAccountingContainer
      },      
      {
        path: "/accounting/codejournal",
        name: "ids_codeJournal",
        mini: "CJ",
        component: AsyncCodeJournalContainer
      }
    ]
  },
  {
    collapse: true,
    path: "/settings/company",
    state: "openSettings",
    icon: "pe-7s-config",
    name: "ids_settings",
    component: Settings,
    views: [
      {
        path: "/settings/company",
        // name: 'Entreprise',
        name: "ids_company",
        mini: "CE",
        component: AsyncCompanyEditPage
      },
      {
        path: "/settings/documents",
        // name: 'Entreprise',
        name: "ids_document",
        mini: "DO",
        component: AsyncDocumentSettingsPage
      },
      {
        path: "/settings/profile",
        name: "ids_profil",
        mini: "UP",
        component: AsyncProfilePage
      },

      {
        path: "/settings/projects",
        name: "ids_projects",
        mini: "PJ",
        // component: AsyncProjectSettingsContainer
        component: ProjectSettingsContainer
      },
      // {
      //   path: "/settings/onboarding",
      //   name: "NewCompany",
      //   mini: "NC",
      //   component: AsyncOnboardingWizard
      // },
      // {
      //   path: "/settings/articles",
      //   name: "dash_articles",
      //   mini: "AR",
      //   component: AsyncArticles
      // },
      {
        path: "/settings/categories",
        name: "ids_categories",
        mini: "CA",
        component: AsyncCategoriesContainer
      },
      {
        path: "/settings/articles",
        name: "ids_articles",
        mini: "AR",
        component: AsyncArticles
      },
      {
        path: "/settings/taxes",
        name: "ids_taxes",
        mini: "TX",
        component: TaxContainer
      }
    ]
  }

  //   {
  //     collapse: true,
  //     path: "/devis",
  //     name: "Devis",
  //     state: "openDevis",
  //     icon: "pe-7s-plugin",
  //     views: [{}]
  //   },

  // all below is from theme - kept for reference
  // { path: "/superadmin", name: "SuperAdmin", component: SuperAdmin },
  // { collapse: true, path: "/components", name: "Components", state: "openComponents", icon: "pe-7s-plugin", views:[
  //     { path: "/components/buttons", name: "Buttons", mini: "B", component: Buttons },
  //     { path: "/components/grid-system", name: "Grid System", mini: "GS", component: GridSystem },
  //     { path: "/components/panels", name: "Panels", mini: "P", component: Panels },
  //     { path: "/components/sweet-alert", name: "Sweet Alert", mini: "SA", component: SweetAlert },
  //     { path: "/components/notifications", name: "Notifications", mini: "N", component: Notifications },
  //     { path: "/components/icons", name: "Icons", mini: "I", component: Icons },
  //     { path: "/components/typography", name: "Typography", mini: "T", component: Typography }]
  // },
  // { collapse: true, path: "/forms", name: "Forms", state: "openForms", icon: "pe-7s-note2", views:
  //  [
  //    { path: "/forms/regular-forms", name: "Regular Forms", mini: "RF", component: RegularForms },
  //     { path: "/forms/extended-forms", name: "Extended Forms", mini: "EF", component: ExtendedForms },
  //     { path: "/forms/validation-forms", name: "Validation Forms", mini: "VF", component: ValidationForms },

  // { collapse: true, path: "/tables", name: "Tables", state: "openTables", icon: "pe-7s-news-paper", views:
  //     [{ path: "/tables/regular-tables", name: "Regular Tables", mini: "RT", component: RegularTables },
  //     { path: "/tables/extended-tables", name: "Extended Tables", mini: "ET", component: ExtendedTables },
  //     { path: "/tables/data-tables", name: "Data Tables", mini: "DT", component: DataTables }]
  // },
  // { collapse: true, path: "/maps", name: "Maps", state: "openMaps", icon: "pe-7s-map-marker", views:
  //     [{ path: "/maps/google-maps", name: "Google Maps", mini: "GM", component: GoogleMaps },
  //     { path: "/maps/full-screen-maps", name: "Full Screen Map", mini: "FSM", component: FullScreenMap },
  //     { path: "/maps/vector-maps", name: "Vector Map", mini: "VM", component: VectorMap }]
  // },
  // { path: "/charts", name: "Charts", icon: "pe-7s-graph1", component: Charts },
  // { path: "/calendar", name: "Calendar", icon: "pe-7s-date", component: Calendar },
  // { collapse: true, path: "/pages", name: "Pages", state: "openPages", icon:"pe-7s-gift", views:
  //     pages
  // },
  //  { redirect: true, path: "/", pathTo: "/companies", name: "Companies" },
  //  { redirect: true, path: "/profile", pathTo: "/dashboard", name: "Profile" }
];
*/
export default dashRoutes;
